<div class="filter">
    <ng-template customFilter></ng-template>
</div>